
export const borderRadiusLeft = v => {
  return {
    borderTopLeftRadius: v,
    borderBottomLeftRadius: v
  }
}

export const borderRadiusRight = v => {
  return {
    borderTopRightRadius: v,
    borderBottomRightRadius: v
  }
}

export const borderRadiusTop = v => {
  return {
    borderTopLeftRadius: v,
    borderTopRightRadius: v
  }
}

export const borderRadiusBottom = v => {
  return {
    borderBottomLeftRadius: v,
    borderBottomRightRadius: v
  }
}